import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getOrderLineDetails,
    OrderDetailsLineCollectionModel,
    OrderDetailsParams,
} from "@tKgpco/Services/GetOrderLineDetailsService";

type HandlerType = ApiHandler<OrderDetailsParams, OrderDetailsLineCollectionModel[]>;

export const DispatchBeginLoadOrderDetailsLine: HandlerType = props => {
    props.dispatch({
        type: "Custom/Orders/BeginLoadOrderDetailsLine",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getOrderLineDetails(props.apiParameter);
};

export const DispatchCompleteLoadOrderDetailsLine: HandlerType = props => {
    props.dispatch({
        type: "Custom/Orders/CompleteLoadOrderDetailsLine",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadOrderDetailsLine,
    RequestDataFromApi,
    DispatchCompleteLoadOrderDetailsLine,
];

const loadOrderLinesDetails = createHandlerChainRunner(chain, "loadOrderLinesDetails");
export default loadOrderLinesDetails;
